import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";

const styles = (theme) => ({
  redPopup: {
    background: "rgba(232, 66, 89, 0.2)",
    borderRadius: "16.5px",
    fontWeight: "600",
    fontSize: theme.textFontSize,
    color: theme.deviationStopPopupColor,
    lineHeight: "19px",
    padding: "8px",
    marginLeft: "25px",
  },

  greenPopup: {
    background: theme.deviationGreenPopupColor,
    borderRadius: "16.5px",
    fontWeight: "600",
    fontSize: theme.textFontSize,
    color: theme.ToggleIconColor,
    lineHeight: "19px",
    padding: "8px",
    marginLeft: "25px",
  },
});

const MilesPopup = ({ classes, milesAdded }) => {
  return (
    <div className={milesAdded > 0 ? classes.redPopup : classes.greenPopup}>
      {`${milesAdded > 0 ? "Added" : "Reduced"} ${Math.abs(milesAdded)} miles`}
    </div>
  );
};
export default compose(withStyles(styles))(MilesPopup);
